import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getSiteAssets, getUsers } from "../../../../store/thunk/site";
import { get, post, put } from "../../../../api";
import axios from 'axios';
import pdfTemplate from './pdf/Fire Alarm.pdf';
import RiskScoreCard from "./RiskScoreCard";
import { formatDate } from "../../../../utils/dateFormat";
import SiteCheckEngineerSelector from "./shared/SiteCheckEngineerSelector";
import SiteCheckEngineerSignature from "./shared/SiteCheckEngineerSignature";
import useSiteCheckEngineers from "./shared/useSiteCheckEngineers";
import {
    getUkLocalDate,
    getUkLocalDateAsDate,
    isCurrentUkInspectionDate,
  toJavaLocalDateTime,
  toJavaLocalDate,
} from "./shared/siteCheckDateUtils";
import SiteCheckDueSummary from "./shared/SiteCheckDueSummary";
import SiteCheckBackButton from "./shared/SiteCheckBackButton";
import { getSiteCheckErrorMessage } from "./shared/siteCheckErrorMessage";
import { calculateSiteCheckDueDate } from "../../../../utils/siteCheckRecurrence";
import { recordSpecializedInspectionHistory } from "./shared/specializedInspectionHistory";

const InspectionFireCertificate = ({
                                       checkId,
                                       sasToken,
                                       siteAssets = [],
                                       getSiteAssets,
                                       getUsers,
                                       siteSelectedForGlobal = {},
                                       loggedInUserData = {},
                                       siteCheck = {},
                                       onCheckCreated
                                   }) => {
    const license = JSON.parse(localStorage.getItem("license"));
    const [isUploading, setIsUploading] = useState(false);
    const [currentCheckId, setCurrentCheckId] = useState(checkId || null);
    const [showRiskAssessment, setShowRiskAssessment] = useState(false);
    const [actionRaised, setActionRaised] = useState(false);
    const [existingAction, setExistingAction] = useState(null);
    const [inspectionDetails, setInspectionDetails] = useState(null);
    const [isFormEditable, setIsFormEditable] = useState(true);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isNewCheck, setIsNewCheck] = useState(!checkId);
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
    const [pendingHistoryRetry, setPendingHistoryRetry] = useState(null);
    const [isRetryingHistory, setIsRetryingHistory] = useState(false);
    const users = useSelector((state) => state.site.users || []);

    // NEW: Use the Site Check's own site and Open/Done status.
    const authoritativeSiteId = siteCheck?.siteId
        ? Number(siteCheck.siteId)
        : Number(siteSelectedForGlobal?.siteId) || null;
    const checkStatus = inspectionDetails?.status || siteCheck?.status || "Open";
    const [lastEngineerId, setLastEngineerId] = useState(null);

    const [folderIds, setFolderIds] = useState({
        logBooks: null,
        fireLogBook: null,
        fireAlarm: null,
        monthlyTesting: null
    });

    const [formData, setFormData] = useState({
        inspectionChecks: [
            {
                check: 1,
                checkQ: "Fire alarm & detection devices have been tested for correct operation",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 2,
                checkQ: "Fire alarm & detection devices are undamaged, unpainted & unobstructed",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 3,
                checkQ: "Automatic transmission of all signals to alarm receiving centre verified",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 4,
                checkQ: "All monitored circuits have been checked by simulation of fault condition",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 5,
                checkQ: "Printers have been checked, text is legible and supplies available",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 6,
                checkQ: "CIE functions checked for correct operation",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 7,
                checkQ: "The control equipment is in overall good condition",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 8,
                checkQ: "The buildings structure, occupancy and layout have not changed",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
            {
                check: 9,
                checkQ: "System log book examined & faults recorded have been attended to",
                checkSelected: false,
                remarks: "",
                satisfactory: false,
            },
        ],
        additionalComments: "",
        additionalComments1: "",
        additionalComments2: "",
        inspectionDate: getUkLocalDateAsDate(),
        installationName: "",
        installationAddress: "",
        inspectionBy: loggedInUserData?.id,
        batteryCount: 0,
        batteryVoltage: "",
        batteryCapacity: "",
        batteryVented: false,
        falseAlarmsCount: 0,
        falseAlarmsRate: "",
        systemCondition: "",
        batteryTestResults: [
            {
                batteryIdentifier: "A",
                voltage: "",
                charge: "",
                installedDate: null
            },
            {
                batteryIdentifier: "B",
                voltage: "",
                charge: "",
                installedDate: null
            }
        ], files: [],
        user: loggedInUserData,
        actionId: null,
    });

    // NEW: Shared engineer behaviour copied from Air Conditioning.
    const {
        engineerOptions,
        selectedEngineer,
        isLoadingEngineers,
        engineerLoadError,
    } = useSiteCheckEngineers({
        users,
        getUsers,
        siteId: authoritativeSiteId,
        loggedInUserData,
        status: checkStatus,
        selectedEngineerId: formData.inspectionBy,
        selectedEngineerUser: formData.user,
        lastEngineerId,
    leadEngineerId: siteCheck?.leadUserID,
    });

    // NEW: Open = logged-in engineer/current UK date. Done is restored from API.
    useEffect(() => {
        if (siteCheck && Number(siteCheck.checkId) === Number(checkId)) {
            setInspectionDetails(siteCheck);
            const done = siteCheck.status === "Done";
            setIsSubmitted(done);
            setIsFormEditable(!done);
        }

        setLastEngineerId(null);
        setFormData((prev) => ({
            ...prev,
            inspectionBy: siteCheck?.status === "Done" ? "" : (loggedInUserData?.id || ""),
            user: siteCheck?.status === "Done" ? {} : (loggedInUserData || {}),
            inspectionDate: siteCheck?.status === "Open"
                ? getUkLocalDateAsDate()
                : prev.inspectionDate,
        }));
    }, [checkId, authoritativeSiteId, siteCheck?.status, loggedInUserData?.id]);

    // Helper function to fetch PDF as ArrayBuffer
    const fetchPdfTemplate = async () => {
        try {
            const response = await fetch(pdfTemplate);
            if (!response.ok) {
                throw new Error('Failed to load PDF template: ' + response.statusText);
            }

            const arrayBuffer = await response.arrayBuffer();
            const header = new Uint8Array(arrayBuffer, 0, 5);
            const headerStr = String.fromCharCode.apply(null, header);

            if (headerStr !== '%PDF-') {
                throw new Error('Invalid PDF file: Missing PDF header');
            }

            return arrayBuffer;
        } catch (error) {
            console.error('Error loading PDF template:', error);
            throw new Error('Failed to load PDF template: ' + error.message);
        }
    };

    // Function to fetch inspection details
    const fetchInspectionDetails = async (checkId) => {
        try {
            const response = await get(`/api/site-check/check-id/${checkId}`);
            if (!response) {
                console.error('No response received');
                return null;
            }

            const inspectionDetails = {
                checkId: response.checkId,
                siteId: response.siteId,
                type: response.type,
                subType: response.subType,
                category: response.category,
                dueDate: response.dueDate,
                repeatFrequency: response.repeatFrequency,
                status: response.status
            };
            setInspectionDetails(inspectionDetails);
            const isSubmitted = inspectionDetails?.status === 'Done';
            setIsSubmitted(isSubmitted);
            setIsFormEditable(!isSubmitted);

            return inspectionDetails;
        } catch (error) {
            console.error('Error fetching inspection details:', error);
            return null;
        }
    };

    const handleRiskAssessmentComplete = async (actionResponse) => {
        try {
            if (!actionResponse?.actionId) {
                throw new Error("Invalid action response received");
            }

            // Verify the action exists
            const verifiedAction = await fetchActionById(actionResponse.actionId);
            if (!verifiedAction) {
                throw new Error("Failed to verify created action");
            }

            // Update the action with checkId if we have one
            if (currentCheckId && !verifiedAction.checkId) {
                await put(`/api/site/actions/${verifiedAction.actionId}`, {
                    ...verifiedAction,
                    checkId: currentCheckId
                });
                verifiedAction.checkId = currentCheckId;
            }

            // Update all relevant states
            setExistingAction(verifiedAction);
            setActionRaised(true);
            setFormData(prev => ({
                ...prev,
                actionId: verifiedAction.actionId
            }));

            // Save the inspection data with the actionId
            const inspectionPayload = {
                ...formData,
                siteId: authoritativeSiteId,
                checkId: currentCheckId,
                actionId: verifiedAction.actionId,
                inspectionBy: formData.inspectionBy,
                type: 'Inspection',
                subType: 'Fire Alarm',
                category: inspectionDetails?.category || 'Fire Alarm'
            };

            if (currentCheckId) {
                const existingInspections = await get(`/api/site-check/fire-alarm-inspection/${currentCheckId}`);
                if (existingInspections?.length > 0) {
                    await put(`/api/site-check/fire-alarm-inspection/${currentCheckId}`, inspectionPayload);
                } else {
                    await post(`/api/site-check/fire-alarm-inspection`, inspectionPayload);
                }
            }

            toast.success(`Action #${verifiedAction.actionId} successfully created and linked`);
        } catch (error) {
            console.error("Error handling risk assessment completion:", error);
            toast.error(getSiteCheckErrorMessage(error, "Failed to process action completion"));
            setActionRaised(false);
            setExistingAction(null);
            setFormData(prev => ({ ...prev, actionId: null }));
        }
    };

    // Replace the existing useEffect that controls showRiskAssessment
    useEffect(() => {

        const hasAdditionalComments = formData.additionalComments.trim().length > 0;

        const isActionValid = existingAction &&
            (Number(existingAction.checkId) === Number(currentCheckId));

        setShowRiskAssessment(hasAdditionalComments);
        setActionRaised(isActionValid);
    }, [formData.additionalComments, currentCheckId, existingAction]);


    const fetchActionById = async (id) => {
        try {
            if (!id) return null;
            const response = await get(`/api/site/actions/id/${id}`);
            return response;
        } catch (error) {
            console.error("Error fetching action:", error);
            return null;
        }
    };

    const fetchExistingActions = async () => {
        try {
            if (formData.actionId) {
                const action = await fetchActionById(formData.actionId);
                if (action && Number(action.checkId) === Number(currentCheckId)) {
                    setExistingAction(action);
                    setActionRaised(true);
                    return;
                }
                setFormData(prev => ({ ...prev, actionId: null }));
            }

            if (!authoritativeSiteId || !currentCheckId) return;

            const response = await get(`/api/site/actions/${authoritativeSiteId}`);
            if (response && response.length > 0) {
                const relevantActions = response.filter(action =>
                    Number(action.checkId) === Number(currentCheckId)
                );

                if (relevantActions.length > 0) {
                    const mostRecentAction = relevantActions.sort((a, b) =>
                        new Date(b.createdAt) - new Date(a.createdAt)
                    )[0];

                    setExistingAction(mostRecentAction);
                    setActionRaised(true);
                    setFormData(prev => ({
                        ...prev,
                        actionId: mostRecentAction.actionId
                    }));
                }
            }
        } catch (error) {
            console.error("Error fetching existing actions:", error);
        }
    };

    // Generate PDF function
    const generatePDF = async (inspectionDateOverride, resolvedCheckId = null) => {
        try {
            setIsGeneratingPDF(true);

            // Ensure we have inspection details
            let inspectionDetails = null;
            if (currentCheckId) {
                inspectionDetails = await fetchInspectionDetails(currentCheckId);
            }

            // NEW: Use the exact engineer/date selected for this submission.
            const effectiveInspectionDate =
                inspectionDateOverride || formData.inspectionDate;
            const effectiveEngineer = formData.user || selectedEngineer || loggedInUserData || {};

            // Generate PDF content
            const { PDFDocument } = await import('pdf-lib');
            const pdfBytes = await fetchPdfTemplate();
            const pdfDoc = await PDFDocument.load(pdfBytes);
            const form = pdfDoc.getForm();

            // Helper functions for setting form fields
            const setTextField = (fieldName, value, fontSize = 8) => {
                try {
                    const field = form.getTextField(fieldName);
                    if (field) {
                        field.setText(value || '');
                        try {
                            if (field.setFontSize) {
                                field.setFontSize(fontSize);
                            }
                        } catch (e) {
                            console.warn(`Could not set font size for ${fieldName}:`, e);
                        }
                    } else {
                        console.warn(`Field not found: ${fieldName}`);
                    }
                } catch (error) {
                    console.warn(`Error setting field ${fieldName}:`, error.message);
                }
            };

            const setCheckbox = (fieldName, isChecked) => {
                try {
                    const field = form.getCheckBox(fieldName);
                    if (field) {
                        if (isChecked) {
                            field.check();
                        } else {
                            field.uncheck();
                        }
                    } else {
                        console.warn(`Checkbox not found: ${fieldName}`);
                    }
                } catch (error) {
                    console.warn(`Error setting checkbox ${fieldName}:`, error.message);
                }
            };

            // Set client information
            setTextField('Name', license?.companyName || '');
            setTextField('Address', license?.companyAddress || '');

            // Set installation information
            setTextField('Name_2', formData.installationName || '');
            setTextField('Address_2', formData.installationAddress || '');

            // Set inspection company info
            setTextField('inspectionTest', effectiveEngineer?.companyName || loggedInUserData?.companyName || '');
            setTextField('Address_3', effectiveEngineer?.companyAddress || loggedInUserData?.companyAddress || '');

            // Set inspection date
            const formattedDate = effectiveInspectionDate
                ? new Date(effectiveInspectionDate).toLocaleDateString('en-GB')
                : '';
            setTextField('Date', formattedDate);

            // Process inspection checks
            for (let i = 1; i <= 9; i++) {
                setCheckbox(`CheckBox${i}`, false);
            }

            formData.inspectionChecks.forEach((check, index) => {
                if (index < 9) {
                    const checkboxName = `CheckBox${index + 1}`;
                    if (check.checkSelected !== undefined) {
                        setCheckbox(checkboxName, check.checkSelected);
                    }
                    if (check.satisfactory === true) {
                        const rightCheckboxName = `CheckBox${index + 10}`;
                        setCheckbox(rightCheckboxName, true);
                    }
                    const remarksField = `Remarks${index + 1}`;
                    if (check.remarks) {
                        setTextField(remarksField, check.remarks);
                    }
                }
            });

            // Set battery information
            setTextField('BatteryCount', formData.batteryCount.toString() || '');
            setTextField('BatteryVoltage', formData.batteryVoltage || '');
            setTextField('BatteryCapacity', formData.batteryCapacity || '');
            setCheckbox('BatteryVented', formData.batteryVented);

            formData.batteryTestResults.slice(0, formData.batteryCount).forEach((battery, index) => {
                setTextField(`voltage${index + 1}`, battery.voltage || '');
                setTextField(`charge${index + 1}`, battery.charge || '');
                setTextField(`installedDate${index + 1}`,
                    battery.installedDate ? formatDate(battery.installedDate) : '');
            });

            // Set false alarm information
            setTextField('FalseAlarmsCount', formData.falseAlarmsCount || '');
            setTextField('FalseAlarmsRate', formData.falseAlarmsRate || '');
            setTextField('details', inspectionDetails?.category || '');


            // Set system condition
            setCheckbox('SystemConditionSatisfactory', formData.systemCondition === 'satisfactory');
            setCheckbox('SystemConditionUnsatisfactory', formData.systemCondition === 'unsatisfactory');

            // Set additional comments
            setTextField('additionalComments', formData.additionalComments || '');
            setTextField('additionalComments1', formData.additionalComments1 || '');
            setTextField('additionalComments2', formData.additionalComments2 || '');

            // OLD:
            // const inspector = users.find(u => u.id === loggedInUserData?.id);
            // Engineer/position/signature all came from the logged-in user.
            // NEW: use the selected inspection engineer.
            const inspector = effectiveEngineer;
            setTextField('Engineer', inspector?.name || '');
            setTextField('Position', inspector?.role || '');

            // Add the selected engineer signature if available.
            if (inspector?.signature) {
                try {
                    const signatureUrl = `${inspector.signature}?${sasToken}`;
                    const signatureResponse = await fetch(signatureUrl);
                    const signatureImageBytes = await signatureResponse.arrayBuffer();

                    let signatureImage;

                    // Try PNG first, then JPG if that fails
                    try {
                        signatureImage = await pdfDoc.embedPng(signatureImageBytes);
                    } catch (pngError) {
                        try {
                            signatureImage = await pdfDoc.embedJpg(signatureImageBytes);
                        } catch (jpgError) {
                            console.warn('Signature image is neither PNG nor JPG:', jpgError);
                            return;
                        }
                    }

                    const signatureField = form.getButton('signature_af_image');
                    if (signatureField) {
                        signatureField.setImage(signatureImage);
                    }
                } catch (error) {
                    console.warn('Error setting signature image:', error);
                }
            }

            // Flatten the form to make it non-editable
            try {
                form.flatten();
            } catch (error) {
                console.warn('Error flattening form:', error.message);
            }

            // Save the modified PDF
            const pdfBytesModified = await pdfDoc.save();
            const blob = new Blob([pdfBytesModified], { type: 'application/pdf' });

            console.log('inspectionDetails:', inspectionDetails);
            console.log('inspectionDetails?.category:', inspectionDetails?.category);

            const category = inspectionDetails?.category || 'report';
            const fileName = `FireAlarmInspection_${category}.pdf`;

            console.log('Generated filename:', fileName);

            // Upload to server
            const uploadResult = await uploadPdfToServer(
                blob,
                fileName,
                inspectionDetails?.category || 'Fire Alarm',
                effectiveInspectionDate,
                resolvedCheckId
            );
            if (!uploadResult?.stored) {
                throw new Error("The Fire Alarm PDF was generated but could not be stored in Site Documents.");
            }

            return { success: true, fileName, uploadResult };
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error('Failed to generate PDF: ' + error.message);
            return { success: false, error: error.message };
        } finally {
            setIsGeneratingPDF(false);
        }
    };

    // Function to save PDF to local storage
    const savePdfToLocal = async (pdfBlob, fileName) => {
        try {
            const blobUrl = URL.createObjectURL(pdfBlob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
            return true;
        } catch (error) {
            console.error('Error saving PDF locally:', error);
            return false;
        }
    };

    const normalizeFolderName = (name) => String(name || '').trim().replace(/\s+/g, ' ');

    const getFolderNamesFromCategory = (category) => {
        // Prefer the current frequency-specific folders. The repository's standard folder.csv
        // also defines "Fire Alarm Weekly In House Testing" and "Fire Alarm Service & Test Records".
        switch (category) {
            case 'Fire Alarm - Weekly Call Point testing to meet BS5839':
                return ['Fire Alarm - Weekly Testing', 'Fire Alarm Weekly In House Testing'];
            case 'Fire Alarm - monthly testing to meet BS5839':
                return ['Fire Alarm - Monthly Testing', 'Fire Alarm Service & Test Records'];
            case 'Fire Alarm - 6 monthly testing to meet BS5839':
                return ['Fire Alarm - 6 Monthly Testing', 'Fire Alarm Service & Test Records'];
            case 'Fire Alarm - 12 monthly testing to meet BS5839':
                return ['Fire Alarm - 12 Monthly Testing', 'Fire Alarm Service & Test Records'];
            default:
                return ['Fire Alarm - Monthly Testing', 'Fire Alarm Service & Test Records'];
        }
    };

    const handleBatteryChange = (index, field, value) => {
        const updatedBatteries = [...formData.batteryTestResults];
        updatedBatteries[index][field] = value;
        setFormData(prev => ({
            ...prev,
            batteryTestResults: updatedBatteries
        }));
    };

    // Fetch folder structure function
    const fetchFolderStructure = async (siteId, category) => {
        try {
            // 1. Get parent folders. Both names are already used by CAFM folder structures.
            const parentFoldersResponse = await get(`/api/document/site/${siteId}/parent/folders`);
            if (!parentFoldersResponse?.parentFolders) {
                throw new Error('No parent folders found');
            }

            const logBooksNames = new Set(['6 - Log Books', 'Log Books'].map(normalizeFolderName));
            const logBooksFolder = parentFoldersResponse.parentFolders.find(
                f => logBooksNames.has(normalizeFolderName(f.name))
            );
            if (!logBooksFolder) {
                throw new Error('Neither "6 - Log Books" nor "Log Books" folder was found');
            }

            // 2. Get Fire Log Book children.
            const logBooksChildren = await get(`/api/document/parent/${logBooksFolder.id}/folders?siteId=${siteId}`);
            const fireLogBookFolder = logBooksChildren?.document?.childFolders?.find(
                f => normalizeFolderName(f.name) === 'Fire Log Book'
            );
            if (!fireLogBookFolder) throw new Error('Fire Log Book folder not found');

            // 3. Support both verified Fire Alarm folder names:
            //    current component: Fire Alarm(BS5839)
            //    repository folder.csv: Fire Alarm (BS5839)
            const fireLogChildren = await get(`/api/document/parent/${fireLogBookFolder.id}/folders?siteId=${siteId}`);
            const fireAlarmNames = new Set(['Fire Alarm(BS5839)', 'Fire Alarm (BS5839)'].map(normalizeFolderName));
            const fireAlarmFolder = fireLogChildren?.document?.childFolders?.find(
                f => fireAlarmNames.has(normalizeFolderName(f.name))
            );
            if (!fireAlarmFolder) {
                throw new Error('Neither "Fire Alarm(BS5839)" nor "Fire Alarm (BS5839)" folder was found');
            }

            // 4. Prefer the current frequency-specific folder. If it is not present, use only
            //    the matching standard folder documented in site-service/src/main/resources/folder.csv.
            const targetFolderNames = getFolderNamesFromCategory(category);
            const targetFolderNamesNormalized = targetFolderNames.map(normalizeFolderName);
            const fireAlarmChildren = await get(`/api/document/parent/${fireAlarmFolder.id}/folders?siteId=${siteId}`);
            const availableFolders = fireAlarmChildren?.document?.childFolders || [];

            let targetFolder = null;
            for (const candidate of targetFolderNamesNormalized) {
                targetFolder = availableFolders.find(f => normalizeFolderName(f.name) === candidate);
                if (targetFolder) break;
            }

            console.log('Searching Fire Alarm folders:', targetFolderNames);
            console.log('Available Fire Alarm subfolders:', availableFolders.map(f => `${f.name} (${f.id})`));

            if (!targetFolder) {
                throw new Error(`Fire Alarm target folder not found. Expected one of: ${targetFolderNames.join(', ')}`);
            }

            const newFolderIds = {
                logBooks: logBooksFolder.id,
                fireLogBook: fireLogBookFolder.id,
                fireAlarm: fireAlarmFolder.id,
                monthlyTesting: targetFolder.id
            };

            console.log('Final folder IDs:', newFolderIds);
            setFolderIds(newFolderIds);
            return newFolderIds.monthlyTesting;

        } catch (error) {
            console.error('Folder structure error:', {
                error: error.message,
                siteId,
                category
            });
            return null;
        }
    };

    const calculateExpiryDate = (visitDate, repeatFrequency) =>
      calculateSiteCheckDueDate(visitDate, repeatFrequency);

    const uploadPdfToServer = async (pdfBlob, fileName, category, inspectionDateOverride, resolvedCheckId = null) => {
        let sourceReference = null;
        try {
            setIsUploading(true);
            const parsedCheckId = Number(resolvedCheckId || currentCheckId);
            if (!Number.isInteger(parsedCheckId) || parsedCheckId <= 0) {
                throw new Error("Fire Alarm PDF cannot be stored without a valid Site Check ID.");
            }
            sourceReference = `FAI-${parsedCheckId}-${Date.now()}`;
            const inspectionDateForUpload =
                inspectionDateOverride || formData.inspectionDate;

            // First save locally
            await savePdfToLocal(pdfBlob, fileName);

            // Ensure we have the latest folder structure
            const targetFolderId = await fetchFolderStructure(authoritativeSiteId, category);
            if (!targetFolderId) {
                throw new Error('Could not determine target folder for PDF upload');
            }

            const pdfFile = new File([pdfBlob], fileName, { type: 'application/pdf' });
            const uploadFormData = new FormData();

            // Check if file exists
            const { exists, file: existingFile } = await checkFileExists(targetFolderId, fileName);

            if (exists && existingFile) {
                // Update existing file
                uploadFormData.append('file', pdfFile);

                const documentRequest = {
                    folderId: targetFolderId,
                    files: [{
                        id: existingFile.id,
                        name: fileName,
                        originalFileName: fileName,
                        fileVersion: (existingFile.fileVersion || 1) + 1,
                        siteId: authoritativeSiteId,
                        issueDate: toJavaLocalDateTime(inspectionDateForUpload),
                        expiryDate: toJavaLocalDateTime(calculateExpiryDate(inspectionDateForUpload, inspectionDetails?.repeatFrequency)),
                        uploaderUserId: loggedInUserData?.id,
                        reviewerUserId: loggedInUserData?.id,
                        referenceNumber: sourceReference
                    }]
                };

                uploadFormData.append('documentRequestString', JSON.stringify(documentRequest));

                const response = await axios.put(
                    '/api/document/file/newVersion/upload',
                    uploadFormData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if ([200, 201, 204].includes(response?.status)) {
                    toast.success(`PDF updated successfully as version ${documentRequest.files[0].fileVersion}`);
                    return { stored: true, sourceReference };
                }
            } else {
                // Create new file
                uploadFormData.append('files', pdfFile);

                const fileVersion = await getHighestFileVersion(targetFolderId, fileName);

                const documentRequest = {
                    folderId: targetFolderId,
                    files: [{
                        name: fileName.split('.')[0],
                        originalFileName: fileName,
                        fileVersion: fileVersion,
                        siteId: authoritativeSiteId,
                        issueDate: toJavaLocalDateTime(inspectionDateForUpload),
                        expiryDate: toJavaLocalDateTime(calculateExpiryDate(inspectionDateForUpload, inspectionDetails?.repeatFrequency)),
                        uploaderUserId: loggedInUserData?.id,
                        reviewerUserId: loggedInUserData?.id,
                        referenceNumber: sourceReference
                    }]
                };

                uploadFormData.append('documentRequestString', JSON.stringify(documentRequest));

                const response = await axios.post(
                    '/api/document/files/upload',
                    uploadFormData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                if ([200, 201, 204].includes(response?.status)) {
                    toast.success(`PDF uploaded successfully as version ${fileVersion}`);
                    return { stored: true, sourceReference };
                }
            }
        } catch (error) {
            console.error('Error uploading PDF:', error);
            toast.error('Failed to upload PDF: ' + error.message);
            return { stored: false, sourceReference: null };
        } finally {
            setIsUploading(false);
        }
    };

    const checkFileExists = async (folderId, fileName) => {
        try {
            const siteId = authoritativeSiteId;
            if (!siteId || !folderId) return { exists: false, file: null };

            const response = await get(`/api/document/parent/${folderId}/folders?siteId=${siteId}`);
            const files = response?.document?.files || [];

            const baseName = fileName.split('.')[0];
            const existingFile = files.find(file =>
                file.name && file.name.startsWith(baseName)
            );

            return {
                exists: !!existingFile,
                file: existingFile || null
            };
        } catch (error) {
            console.error('Error checking file existence:', error);
            return { exists: false, file: null };
        }
    };

    const getHighestFileVersion = async (folderId, fileName) => {
        try {
            const siteId = authoritativeSiteId;
            if (!siteId || !folderId) return 1;

            const response = await get(`/api/document/parent/${folderId}/folders?siteId=${siteId}`);
            const files = response?.document?.files || [];

            const baseName = fileName.split('.')[0];
            const matchingFiles = files.filter(file =>
                file.name && file.name.startsWith(baseName)
            );

            if (matchingFiles.length > 0) {
                const versions = matchingFiles.map(f => f.fileVersion || 1);
                const maxVersion = Math.max(...versions);
                return maxVersion + 1;
            }
            return 1;
        } catch (error) {
            console.error('Error checking file versions:', error);
            return 1;
        }
    };

    const getInspection = async () => {
        try {
            const apiData = await get(`/api/site-check/fire-alarm-inspection/${checkId}`);

            if (apiData) {
                let existingAction = null;
                if (apiData.actionId) {
                    existingAction = await fetchActionById(apiData.actionId);
                    if (existingAction) {
                        setExistingAction(existingAction);
                        setActionRaised(true);
                    }
                }
                const batteryData = apiData.batteryTestResults || [];
                const defaultBatteries = [
                    { batteryIdentifier: "A", voltage: "", charge: "", installedDate: null },
                    { batteryIdentifier: "B", voltage: "", charge: "", installedDate: null }
                ];

                const loadedBatteries = defaultBatteries.map((battery, index) => {
                    return batteryData[index] ? { ...battery, ...batteryData[index] } : battery;
                });



                // Create a map of checks from API data for easier lookup
                const apiChecksMap = {};
                apiData.inspectionChecks?.forEach(check => {
                    apiChecksMap[check.check] = check;
                });

                const savedEngineerId = apiData?.inspectionBy || apiData?.inspectionByUser?.id || null;
                setLastEngineerId(savedEngineerId);
                const engineerUser = apiData?.inspectionByUser ||
                    users.find((u) => String(u.id) === String(savedEngineerId));
                const isCurrentOpenInspection =
                    checkStatus === "Open" &&
                    isCurrentUkInspectionDate(apiData?.inspectionDate);

                setFormData(prev => ({
                    ...prev,
                    id: apiData?.id || prev.id,
                    installationName: apiData?.installationName || prev.installationName,
                    installationAddress: apiData?.installationAddress || prev.installationAddress,
                    batteryCount: Math.min(batteryData.length, 2), // Ensure max 2 batteries
                    batteryTestResults: loadedBatteries,
                    batteryVoltage: apiData?.batteryVoltage || prev.batteryVoltage,
                    batteryCapacity: apiData?.batteryCapacity || prev.batteryCapacity,
                    batteryVented: apiData?.batteryVented || prev.batteryVented,
                    falseAlarmsCount: apiData?.falseAlarmsCount || prev.falseAlarmsCount,
                    falseAlarmsRate: apiData?.falseAlarmsRate || prev.falseAlarmsRate,
                    systemCondition: apiData?.systemCondition || prev.systemCondition,
                    inspectionChecks: prev.inspectionChecks.map(defaultCheck => {
                        const apiCheck = apiChecksMap[defaultCheck.check];
                        return {
                            ...defaultCheck,
                            ...(apiCheck || {}),
                            checkQ: defaultCheck.checkQ
                        };
                    }),
                    actionId: apiData?.actionId || prev.actionId,
                    additionalComments: apiData?.additionalComments || prev.additionalComments,
                    additionalComments1: apiData?.additionalComments1 || prev.additionalComments1,
                    additionalComments2: apiData?.additionalComments2 || prev.additionalComments2,
                    files: apiData?.files || prev.files,

                    // OLD: user: apiData?.inspectionByUser || prev.user,
                    // NEW: same Open/Done engineer/date behaviour as Air Conditioning.
                    inspectionBy: checkStatus === "Open"
                        ? (isCurrentOpenInspection
                            ? (savedEngineerId || loggedInUserData?.id || "")
                            : (loggedInUserData?.id || ""))
                        : (savedEngineerId || prev.inspectionBy || ""),
                    user: checkStatus === "Open"
                        ? (isCurrentOpenInspection
                            ? (engineerUser || loggedInUserData || {})
                            : (loggedInUserData || {}))
                        : (engineerUser || prev.user || {}),
                    inspectionDate: checkStatus === "Open"
                        ? getUkLocalDateAsDate()
                        : (apiData?.inspectionDate
                            ? new Date(`${String(apiData.inspectionDate).slice(0, 10)}T12:00:00`)
                            : prev.inspectionDate),
                }));



                setCompleted(true);
            }
        } catch (error) {
            console.error("Inspection load error:", error);
            toast.error("Failed to load inspection data");
        }
    };

    // const fetchCheckStatus = async () => {
    //   try {
    //     if (!checkId) return;

    //     const response = await get(`api/site-check/check-id/${checkId}`);
    //     if (response) {
    //       const isDone = response.status === 'Done';
    //       setIsFormEditable(!isDone);
    //       setIsSubmitted(isDone);

    //       if (isDone) {
    //         setInspectionDetails({
    //           type: response.type,
    //           subType: response.subType,
    //           category: response.category,
    //           dueDate: response.dueDate,
    //           status: response.status,
    //           checkId: response.checkId,
    //           siteId: response.siteId,
    //         });
    //       }
    //     }
    //   } catch (error) {
    //     console.error('Error fetching check status:', error);
    //   }
    // };

    useEffect(() => {
        const syncActionState = async () => {
            if (formData.actionId) {
                const action = await fetchActionById(formData.actionId);
                if (action) {
                    setExistingAction(action);
                    setActionRaised(true);
                }
            }
        };
        syncActionState();
    }, [formData.actionId]);

    useEffect(() => {
        const fetchData = async () => {
            if (users.length === 0) {
              getUsers();
            }
            if (authoritativeSiteId) {
                await fetchFolderStructure(authoritativeSiteId, 'Fire Alarm');
            }

            if (checkId) {
                await getInspection();
            }

            await fetchExistingActions();

            if (authoritativeSiteId) {
                getSiteAssets(authoritativeSiteId);
            }
        };

        fetchData();
    }, [authoritativeSiteId, checkId]);

    useEffect(() => {
        if (license?.companyName) {
            setFormData((prev) => ({
                ...prev,
                installationName: license.companyName,
            }));
        }

        if (!siteSelectedForGlobal.siteId) {
            return;
        }

        const addressParts = [
            siteSelectedForGlobal.address1,
            siteSelectedForGlobal.address2,
            siteSelectedForGlobal.city,
            siteSelectedForGlobal.area,
            siteSelectedForGlobal.postCode,
            siteSelectedForGlobal.country,
        ].filter((part) => part);

        const fullAddress = addressParts.join(", ");

        setFormData((prev) => ({
            ...prev,
            installationAddress: fullAddress,
        }));
    }, [license?.companyName, siteSelectedForGlobal]);

    const handleInputChange = (e, field) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleCheckChange = (index, field, value) => {
        const updatedChecks = [...formData.inspectionChecks];
        updatedChecks[index][field] = value;

        if (field === "checkSelected") {
            updatedChecks[index].satisfactory = value;
        }

        setFormData(prev => ({
            ...prev,
            inspectionChecks: updatedChecks,
        }));
    };

    const handleDateChange = (date) => {
        setFormData(prev => ({ ...prev, inspectionDate: date || getUkLocalDateAsDate() }));
    };



    // NEW: Shared engineer dropdown selection.
    const handleEngineerSelect = (event, newValue) => {
        setFormData((prev) => ({
            ...prev,
            inspectionBy: newValue?.id || "",
            user: newValue || {},
        }));
    };

    const submitInspection = async (e) => {
        e.preventDefault();

        if (!isFormEditable) {
            toast.error("This form is completed and cannot be modified");
            return;
        }

        if (!formData.systemCondition) {
            toast.error("Please select system condition (Satisfactory/Unsatisfactory)");
            return;
        }

        if (!formData.inspectionBy || !selectedEngineer) {
            toast.error("Please select an active engineer for this Site Check.");
            return;
        }



        const hasAdditionalComments = formData.additionalComments.trim().length > 0;

        if (hasAdditionalComments && !actionRaised) {
            toast.error("Please complete the risk assessment before submitting");
            return;
        }

        setIsLoading(true);

        try {
            const submissionInspectionDate = formData.inspectionDate;
            const submissionDateString = getUkLocalDate(submissionInspectionDate);

            // 1. First create/update site check record
            const statusPayload = {
                siteId: authoritativeSiteId,
                type: siteCheck?.type || 'Inspection',
                // OLD: subType/category were replaced with generic Fire Alarm values.
                // NEW: preserve the original UpdateSiteCheck routing values.
                subType: siteCheck?.subType || 'Fire Alarm to meet BS5839',
                category: siteCheck?.category || inspectionDetails?.category || 'Fire Alarm',
                status: 'Done',
                startDate: toJavaLocalDateTime(submissionInspectionDate),
                dueDate: toJavaLocalDateTime(calculateExpiryDate(submissionInspectionDate, inspectionDetails?.repeatFrequency)),
                leadUserID: loggedInUserData?.id,
                assistantUserID: loggedInUserData?.id
            };

            let checkIdToUse = currentCheckId;
            const statusResponse = checkIdToUse
                ? await put(`/api/site-check/${checkIdToUse}/completion`, statusPayload)
                : await post('/api/site-check', statusPayload);

            if (!checkIdToUse && (statusResponse?.data?.checkId || statusResponse?.checkId)) {
                checkIdToUse = statusResponse?.data?.checkId || statusResponse?.checkId;
                setCurrentCheckId(checkIdToUse);
            }
            const resolvedCheckId = Number(checkIdToUse);
            if (!Number.isInteger(resolvedCheckId) || resolvedCheckId <= 0) {
                throw new Error("The completed Fire Alarm Site Check did not return a valid Check ID.");
            }

            // 2. Save inspection data
            const inspectionPayload = {
                ...formData,
                siteId: authoritativeSiteId,
                checkId: checkIdToUse,
                inspectionBy: formData.inspectionBy,
                inspectionDate: toJavaLocalDate(submissionInspectionDate),
                actionId: existingAction?.actionId || formData.actionId,
                batteryTestResults: formData.batteryTestResults.slice(0, formData.batteryCount)
            };

            const inspectionResponse = formData.id
                ? await put(`/api/site-check/fire-alarm-inspection/${resolvedCheckId}`, inspectionPayload)
                : await post("/api/site-check/fire-alarm-inspection", inspectionPayload);
            if (![200, 201, 204].includes(inspectionResponse?.status)) {
                throw new Error("Failed to save Fire Alarm inspection data");
            }
            const inspectionRecordId = Number(inspectionResponse?.data?.id);
            if (!Number.isInteger(inspectionRecordId) || inspectionRecordId <= 0) {
                throw new Error("The saved Fire Alarm inspection did not return a valid inspection record ID.");
            }

            // 3. Generate and upload PDF
            const pdfResult = await generatePDF(submissionInspectionDate, resolvedCheckId);
            if (!pdfResult.success || !pdfResult?.uploadResult?.stored || !pdfResult?.uploadResult?.sourceReference) {
                throw new Error(pdfResult.error || "Failed to generate or store PDF");
            }

            const historyPayload = {
                checkId: resolvedCheckId,
                inspectionRecordId,
                sourceReference: pdfResult.uploadResult.sourceReference,
            };
            try {
                await recordSpecializedInspectionHistory(historyPayload);
                setPendingHistoryRetry(null);
            } catch (historyError) {
                const historyMessage = getSiteCheckErrorMessage(historyError, "History record could not be created.");
                console.error("Record Fire Alarm history:", { ...historyPayload, status: historyError?.response?.status, message: historyMessage, error: historyError });
                setPendingHistoryRetry(historyPayload);
                setIsSubmitted(true);
                setIsFormEditable(false);
                toast.error(`Inspection and PDF were saved, but History was not recorded: ${historyMessage}`);
                return;
            }

            // 4. Update state
            toast.success("Inspection submitted and History recorded successfully");
            setIsSubmitted(true);
            setIsFormEditable(false);

            if (onCheckCreated && isNewCheck) {
                onCheckCreated(checkIdToUse);
            }

        } catch (error) {
            console.error("Submission error:", error);
            toast.error(getSiteCheckErrorMessage(error, "Failed to submit inspection"));
        } finally {
            setIsLoading(false);
        }
    };

    const retryPendingHistory = async () => {
        if (!pendingHistoryRetry || isRetryingHistory) return;
        setIsRetryingHistory(true);
        try {
            const history = await recordSpecializedInspectionHistory(pendingHistoryRetry);
            setPendingHistoryRetry(null);
            toast.success(`History recorded successfully (History #${history.historyId}).`);
        } catch (error) {
            const message = getSiteCheckErrorMessage(error, "History record could not be created.");
            console.error("Retry Fire Alarm history:", { ...pendingHistoryRetry, status: error?.response?.status, message, error });
            toast.error(`History retry failed: ${message}`);
        } finally {
            setIsRetryingHistory(false);
        }
    };

    return (
        <div className="card mb-4">
            <div className="card-header bg-primary text-white">
                <h4>Fire Alarm Inspection & Test Certificate</h4>
                <small>BS5839 – 1: 2013</small>
            </div>

            {!isFormEditable && (
                <div className="alert alert-warning" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    This form is read-only because the check has been marked as completed.
                </div>
            )}

            <div className="card-body">
                <form onSubmit={submitInspection}>
                    {/* Client Details Section */}
                    <h5 className="mb-3">Details of the Client</h5>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={license?.companyName}
                                    disabled
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Address</label>
                                <textarea
                                    rows={4}
                                    className="form-control"
                                    value={license?.companyAddress}
                                    disabled
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Installation Details Section */}
                    <h5 className="mb-3">Details of the Installation</h5>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.installationName}
                                    disabled
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Address</label>
                                <textarea
                                    rows={2}
                                    className="form-control"
                                    value={formData.installationAddress}
                                    disabled
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Extent of System and Variations */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">
                                    The extent of liability of the signatory is limited to the system described. Extent of system covered by this report:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.additionalComments1 || ""}
                                    onChange={(e) => handleInputChange(e, "additionalComments1")}
                                    disabled={!isFormEditable}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">
                                    Variations from the recommendations of Clause 45 of BS 5839-1:2013 for periodic or annual inspection and test:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.additionalComments2 || ""}
                                    onChange={(e) => handleInputChange(e, "additionalComments2")}
                                    disabled={!isFormEditable}
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Summary of Test & Inspection */}
                    <h5 className="mb-3">Summary of Test & Inspection</h5>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Inspection & Test Carried Out By:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={loggedInUserData.companyName || ""}
                                    disabled
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Address:</label>
                                <textarea
                                    rows={2}
                                    className="form-control"
                                    value={loggedInUserData.companyAddress || ""}
                                    disabled
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Inspection Checks Section */}
                    <h5 className="mb-3">Inspection Checks</h5>
                    <table className="table table-striped table-bordered mb-4">
                        <thead>
                        <tr>
                            <th style={{ width: "60%" }}>Check</th>
                            <th style={{ width: "20%" }}>Remarks</th>
                        </tr>
                        </thead>
                        <tbody>
                        {formData.inspectionChecks.map((check, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={check.checkSelected}
                                            onChange={(e) =>
                                                handleCheckChange(index, "checkSelected", e.target.checked)
                                            }
                                            disabled={!isFormEditable}
                                        />
                                        <label className="form-check-label">{check.checkQ}</label>
                                    </div>
                                </td>

                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={check.remarks}
                                        onChange={(e) =>
                                            handleCheckChange(index, "remarks", e.target.value)
                                        }
                                        placeholder="Enter remarks..."
                                        disabled={!isFormEditable}
                                    />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>



                    {/* Battery Information Section */}
                    {/* Battery Information Section */}
                    <div className="card mb-4">
                        <div className="card-header bg-primary text-white">
                            Battery Information
                        </div>
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <div className="form-group mb-3">
                                        <label>No. of Batteries:</label>
                                        <div className="input-group">
                                            <select
                                                className="form-control"
                                                value={formData.batteryCount}
                                                onChange={(e) => {
                                                    const count = parseInt(e.target.value) || 0;
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        batteryCount: count
                                                    }));
                                                }}
                                                disabled={!isFormEditable}
                                            >
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                            </select>
                                            <span className="input-group-text">
                        (for more than 2, record results on a separate numbered page)
                      </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group mb-3">
                                        <label>Battery Voltage:</label>
                                        <div className="input-group">
                                            <input
                                                type="number"
                                                className="form-control"
                                                step="0.1"
                                                value={formData.batteryVoltage}
                                                onChange={(e) => handleInputChange(e, "batteryVoltage")}
                                                disabled={!isFormEditable}
                                            />
                                            <span className="input-group-text">V</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group mb-3">
                                        <label>Battery Capacity:</label>
                                        <div className="input-group">
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.batteryCapacity}
                                                onChange={(e) => handleInputChange(e, "batteryCapacity")}
                                                disabled={!isFormEditable}
                                            />
                                            <span className="input-group-text">Ah</span>
                                        </div>
                                        <small className="text-muted">
                                            (if batteries are vented, make a note in the observations section)
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="border-top pt-3">
                                <h5>Battery Load Test Results</h5>

                                {formData.batteryTestResults.slice(0, formData.batteryCount).map((battery, index) => (
                                    <div key={index} className="row mb-3">
                                        <div className="col-md-12">
                                            <div className="d-flex align-items-center">
                                                <strong className="me-2">Battery {battery.batteryIdentifier}:</strong>
                                                <div className="input-group input-group-sm me-2" style={{ width: "200px" }}>
                                                    <span className="input-group-text">Voltage:</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        step="0.1"
                                                        min={0}
                                                        value={battery.voltage}
                                                        onChange={(e) => handleBatteryChange(index, "voltage", e.target.value)}
                                                        disabled={!isFormEditable}
                                                    />
                                                    <span className="input-group-text">V</span>
                                                </div>
                                                <div className="input-group input-group-sm me-2" style={{ width: "200px" }}>
                                                    <span className="input-group-text">Charge:</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        step="0.01"
                                                        min={0}
                                                        value={battery.charge}
                                                        onChange={(e) => handleBatteryChange(index, "charge", e.target.value)}
                                                        disabled={!isFormEditable}
                                                    />
                                                    <span className="input-group-text">Ah</span>
                                                </div>

                                                <div className="input-group input-group-md me-2" style={{ width: "240px" }}>
                                                    <span className="input-group-text">Date Installed:</span>
                                                    <DatePicker
                                                        selected={battery.installedDate ? new Date(battery.installedDate) : null}
                                                        onChange={(date) => handleBatteryChange(index, "installedDate", date)}
                                                        className="form-control"
                                                        dateFormat="dd/MM/yyyy"
                                                        disabled={!isFormEditable}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className="mt-3">
                                    <small className="text-muted">
                                        (For category M systems, enter not applicable "N/A")
                                    </small>
                                    <div className="form-group">
                                        <p className="mb-1">
                                            During the past 12 months,{" "}
                                            <input
                                                type="number"
                                                min={0}
                                                className="form-control d-inline"
                                                style={{ width: "60px" }}
                                                value={formData.falseAlarmsCount}
                                                onChange={(e) => handleInputChange(e, "falseAlarmsCount")}
                                                disabled={!isFormEditable}
                                            />{" "}
                                            false alarms have occurred.
                                        </p>
                                        <p className="mb-0">
                                            The number of false alarms equates to{" "}
                                            <input
                                                type="text"
                                                className="form-control d-inline"
                                                style={{ width: "80px" }}
                                                value={formData.falseAlarmsRate}
                                                onChange={(e) => handleInputChange(e, "falseAlarmsRate")}
                                                disabled={!isFormEditable}
                                            />{" "}
                                            false alarms per 100 AFD's per annum.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Work/Action Required Section */}
                    <h5 className="mb-1">The following work/action is considered necessary:</h5>
                    <div className="mb-4">
            <textarea
                rows={4}
                className="form-control"
                value={formData.additionalComments}
                onChange={(e) => handleInputChange(e, "additionalComments")}
                placeholder="Describe any necessary work or action..."
                disabled={!isFormEditable}
            />
                    </div>

                    {/* Risk Assessment Section */}
                    {showRiskAssessment && (
                        <div className="card mb-4">
                            <div className="card-header">
                                <h5 className="mb-0">Risk Assessment</h5>
                                {existingAction && Number(existingAction.checkId) === Number(currentCheckId) && (
                                    <span className="badge bg-success ms-2">
                    Action #{existingAction.actionId} - {existingAction.status}
                  </span>
                                )}
                            </div>
                            <div className="card-body">
                                {existingAction && Number(existingAction.checkId) === Number(currentCheckId) ? (
                                    <div className="existing-action">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p><strong>Observation:</strong> {existingAction.observation}</p>
                                                <p><strong>Required Action:</strong> {existingAction.requiredAction}</p>
                                                <p><strong>Risk Score:</strong> {existingAction.riskScore}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Description: </strong> {existingAction.desc}</p>
                                                <p><strong>Due Date:</strong> {formatDate(existingAction.dueDate)}</p>
                                                <p><strong>Status:</strong> {existingAction.status}</p>
                                            </div>
                                        </div>
                                        {existingAction.comments && (
                                            <div className="mt-3">
                                                <h6>Comments:</h6>
                                                <p>{existingAction.comments}</p>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <RiskScoreCard
                                        desc={`Inspection - Fire Alarm to meet BS5839 - ${inspectionDetails?.category || ''}`}
                                        siteId={authoritativeSiteId}
                                        checkId={currentCheckId}
                                        createdBy={loggedInUserData?.id}
                                        onRiskAssessmentComplete={handleRiskAssessmentComplete}
                                        actionRaised={actionRaised}
                                        disabled={!isFormEditable}
                                    />
                                )}
                            </div>
                        </div>
                    )}

                    {/* System Condition Section */}
                    <div className="border p-3 mb-4 bg-light">
                        <p>
                            I/We being the competent person(s) responsible (as indicated by
                            my/our signature(s) below) for the inspection and servicing of the
                            fire alarm system, particulars of which are set out above, CERTIFY
                            that the said work for which I/we have been responsible complies
                            to the best of my/our knowledge and belief with the
                            recommendations of Clause 45 of BS 5839–1: 2013 quarterly
                            inspection of vented batteries/periodic inspection and test over a
                            12 month period except for the variations, if any, stated in this
                            certificate.
                        </p>
                        <p className="mt-3">
                            I/We further declare that in my/our judgement, the said system was overall in:
                        </p>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="systemCondition"
                                id="systemConditionSatisfactory"
                                value="satisfactory"
                                checked={formData.systemCondition === "satisfactory"}
                                onChange={(e) => handleInputChange(e, "systemCondition")}
                                disabled={!isFormEditable}
                            />
                            <label className="form-check-label" htmlFor="systemConditionSatisfactory">
                                a satisfactory
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="systemCondition"
                                id="systemConditionUnsatisfactory"
                                value="unsatisfactory"
                                checked={formData.systemCondition === "unsatisfactory"}
                                onChange={(e) => handleInputChange(e, "systemCondition")}
                                disabled={!isFormEditable}
                            />
                            <label className="form-check-label" htmlFor="systemConditionUnsatisfactory">
                                an unsatisfactory
                            </label>
                        </div>
                        <p className="mt-2">condition at the time the inspection and servicing was carried out, and that it should be further inspected as recommended.</p>
                    </div>

                    {/* Inspector Details Section */}
                    <h5 className="mb-3">For the Inspection & Test of the system:</h5>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            {/* =========================================================
                                OLD ENGINEER NAME FIELD - COMMENTED FOR REVIEW

                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.user?.name || ""}
                                    disabled
                                />
                            </div>

                            ========================================================= */}

                            {/* NEW SHARED ENGINEER CONTROL - MATCHES AIR CONDITIONING */}
                            <SiteCheckEngineerSelector
                                options={engineerOptions}
                                value={selectedEngineer}
                                onChange={handleEngineerSelect}
                                isOpen={checkStatus === "Open"}
                                disabled={isSubmitted || !isFormEditable}
                                loading={isLoadingEngineers}
                                error={engineerLoadError}
                                label="Name"
                            />
                        </div>
                        <div className="col-md-4">
                            <div className="mb-3">
                                <label className="form-label">Position</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.user?.role || ""}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <SiteCheckEngineerSignature
                                engineer={selectedEngineer}
                                engineerId={formData.inspectionBy || formData.user?.id}
                                fallbackSignature={formData.user?.signature || ""}
                                sasToken={sasToken}
                            />
                        </div>
                        <div className="col-md-2">
                            <div className="mb-3">
                                <label className="form-label">Inspection Date</label>
                                <DatePicker
                                    selected={formData.inspectionDate}
                                    onChange={handleDateChange}
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    required
                                    disabled={!isFormEditable}
                                />
                            </div>
                        </div>
                    </div>

                    {/* SiteCheckPersistentSubmittedBack: keep navigation available after submission. */}
          {isSubmitted && (
            <div className="mt-3 print-hide">
              <SiteCheckBackButton />
            </div>
          )}

          {!isSubmitted ? (
                        <div className="d-flex justify-content-between align-items-start mt-3 print-hide">
                            <SiteCheckBackButton />
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={
                                    isLoading ||
                                    isGeneratingPDF ||
                                    (showRiskAssessment && !actionRaised) ||
                                    !isFormEditable
                                }
                            >
                                {isLoading ? 'Submitting...' :
                                    isGeneratingPDF ? 'Generating PDF...' : 'Submit Inspection'}
                            </button>
                        </div>
                    ) : (
                        <div className="alert alert-success">
                            Inspection submitted successfully on {formatDate(formData.inspectionDate)}
                        </div>
                    )}
                {pendingHistoryRetry && (
                    <div className="alert alert-warning d-flex justify-content-between align-items-center mt-3 print-hide">
                        <span>Inspection and PDF are saved, but History still needs to be recorded. Do not submit the inspection again.</span>
                        <button type="button" className="btn btn-warning btn-sm ms-3" onClick={retryPendingHistory} disabled={isRetryingHistory}>
                            {isRetryingHistory ? "Retrying History..." : "Retry History"}
                        </button>
                    </div>
                )}
                {!isSubmitted && (
                  <div className="d-flex justify-content-end print-hide">
                    <SiteCheckDueSummary
                      inspectionDate={formData.inspectionDate}
                      repeatFrequency={siteCheck?.repeatFrequency || inspectionDetails?.repeatFrequency}
                    />
                  </div>
                )}
                </form>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    siteAssets: state.site.siteAssets || [],
    siteSelectedForGlobal: state.site.siteSelectedForGlobal || {},
    loggedInUserData: state.site.loggedInUserData || {},
});

export default connect(mapStateToProps, { getSiteAssets, getUsers })(
    InspectionFireCertificate
);